// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cheap-request .activator{cursor:pointer;font-weight:lighter;padding:5px 15px 5px 0;text-align:right;-webkit-text-decoration:underline;text-decoration:underline;text-decoration-style:dashed;-webkit-user-select:none;-moz-user-select:none;user-select:none}.cheap-request-inner{padding:0 15px}.cheap-request-inner .description{font-size:16px;font-weight:lighter;margin-bottom:15px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
